enum ButtonVariants {
    Primary = 'primary',
    Secondary = 'secondary',
    Link = 'link',
    Transparent = 'transparent',
    Icon = 'icon'
}

export default ButtonVariants;